import { createContext } from 'react';

const Context = createContext(null);

export const { Provider, Consumer } = Context;

export default Context;
